import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=50d0969c&scoped=true&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"
import style0 from "./UserCash.vue?vue&type=style&index=0&id=50d0969c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0969c",
  null
  
)

export default component.exports